export default [
    {
        path: '/inbox',
        name: 'Inbox',
        meta: { layout: 'default' },
        // Chat used to live here behind a ?tab=messages tab; keep old links working.
        beforeEnter(to, from, next) {
            if (to.query.tab === 'messages') {
                return next({ path: '/chats' });
            }
            next();
        },
        component: () => import('../AllNotificationsComponent.vue')
    },
    {
        path: '/chats',
        name: 'Chats',
        meta: { layout: 'default' },
        component: () => import('../InboxComponent.vue')
    }
]
